import { apiFetch } from '@app/utils/utils';
import { AdminScreen, ScreenPathPoint } from '@app/Screens/types';

const BASE = '/api/admin/screens';

export async function getScreens(): Promise<AdminScreen[]> {
  const res = await apiFetch(`${BASE}/status`);
  if (!res.ok) {
    throw new Error(`Failed to load screens (${res.status})`);
  }
  return res.json();
}

/** Enable or disable a screen (toggles the ROLE_SCREEN principal's `enabled`). Audited server-side. */
export async function setScreenEnabled(
  screenId: number,
  enabled: boolean
): Promise<{ screenId: number; enabled: boolean }> {
  const res = await apiFetch(`${BASE}/${screenId}`, {
    method: 'PATCH',
    body: JSON.stringify({ enabled })
  });
  if (!res.ok) {
    throw new Error(`Failed to ${enabled ? 'enable' : 'disable'} screen (${res.status})`);
  }
  return res.json();
}

/**
 * GPS breadcrumb trail for one screen. `since`/`until` are ISO-8601 instants;
 * the backend defaults to the last 24h and caps the result at 10k points.
 */
export async function getScreenPath(
  screenId: number,
  since?: string,
  until?: string
): Promise<ScreenPathPoint[]> {
  const params = new URLSearchParams();
  if (since) params.set('since', since);
  if (until) params.set('until', until);
  const qs = params.toString();
  const res = await apiFetch(`${BASE}/${screenId}/path${qs ? `?${qs}` : ''}`);
  if (!res.ok) {
    throw new Error(`Failed to load screen path (${res.status})`);
  }
  return res.json();
}
